import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { Nav, NavItem } from "react-bootstrap";
import { LinkContainer, IndexLinkContainer } from "react-router-bootstrap";
import { IoChevronBack, IoBriefcase, IoTime, IoAttach } from "react-icons/io5";
import MenuFooter from "./MenuFooter";

const navItems = (project) => [
  {
    to: `/app/projects/${project}`,
    name: "Info",
    icon: <IoBriefcase size={15} />
  },
  {
    to: `/app/projects/${project}/calls`,
    name: "Calls",
    icon: <IoTime size={15} />
  },
  // saved for after go-live
  // {
  //   to: `/app/projects/${project._id}/tasks`,
  //   name: "Tasks",
  //   icon: <FaTasks />
  // },
  {
    to: `/app/projects/${project}/attachments`,
    name: "Attachments",
    icon: <IoAttach size={15} />
  }
];

class ProjectMenu extends Component {
  render() {
    const { location, onClickMenu } = this.props;

    const pathSegments = location.pathname.split("/");
    const projectId = pathSegments[3];

    return (
      <Nav className="sidebar sidebar-nav">
        <IndexLinkContainer to="/app/projects">
          <NavItem eventKey={1} onClick={onClickMenu}>
            <IoChevronBack size={16} />
            All Projects
          </NavItem>
        </IndexLinkContainer>
        {navItems(projectId).map((item, i) => (
          <LinkContainer key={i} exact to={item.to}>
            <NavItem eventKey={i} onClick={onClickMenu}>
              {item.icon}
              <span>{item.name}</span>
            </NavItem>
          </LinkContainer>
        ))}
        <MenuFooter />
      </Nav>
    );
  }
}
ProjectMenu.propTypes = {
  onClickMenu: PropTypes.func,
  location: PropTypes.object
};
function mapStatesToProps(state) {
  return {
    state
  };
}

export default connect(mapStatesToProps, null)(ProjectMenu);
